import { defineStore, acceptHMRUpdate } from 'pinia'
export const useUserInfoStore = defineStore({
  id: 'userInfoStore',
  state: () => ({
    userInfo:{
        avatar:'',
        nickname:'',
        staffId:'',
    }
  }),
  actions: {
    updateUserInfo(userInfo) {
        const {avatar,nickname,staffId} = userInfo;
        this.userInfo.avatar = avatar;
        this.userInfo.nickname = nickname;
        this.userInfo.staffId = staffId;
    }
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserInfoStore, import.meta.hot))
}
